import {
  NEW_INTEGRATION_SAT_DATA,
  NEW_INTEGRATION_SAT_DOWNLOADS,
  NEW_INTEGRATION_SAT_ERRORS,
  NEW_INTEGRATIONS_STATE,
  NEW_PAYMENT_INSTRUCTIONS_DATA,
  NEW_SPEI_DATA,
  NEW_STRIPE_DATA,
  NEW_API_KEY,
  NEW_OXXO_DATA,
  NEW_CONEKTA_DATA,
  NEW_CONTPAQI_DATA,
  GET_RELATION_CONCEPTS,
  SEND_RELATION_CONCEPTS,
  TOGGLE_LOADING,
  UPDATE_INTEGRATION,
  NEW_FISERV_INTEGRATION_DATA,
  NEW_INTEREST_INTEGRATION_DATA,
  UPDATE_INTEREST_INTEGRATION_DATA,
  NEW_SAP_INTEGRATION_DATA,
  GET_STP_INTEGRATION
} from '../actions/integrationsActions';

import {
  RESET_ACCOUNT,
  LOG_OUT
} from '../actions/accountActions';

const initialState = {
  api_key: null,
  manualPayment: null,
  sat: null,
  sat_downloads: null,
  spei: null,
  stripe: null,
  fiserv: null,
  sap_bo: null,
  interest: [],
  interestpatch:[],
  states: null,
  satErrors: null,
  oxxo: null,
  conekta: null,
  contpaqi: null,
  relationConcepts: {},
  isLoading: false,
  stp: null,
  payfac: null
} // END initialState
 

export default function (state = initialState, action) {
  let { payload, type } = action, newState;
  switch (type) {
    // Settings
    case NEW_INTEGRATIONS_STATE:
      return { ...state, ...payload };

    case NEW_PAYMENT_INSTRUCTIONS_DATA:
      newState = { instructions: payload, manualPayment: payload };
      return { ...state, ...newState };

    case NEW_API_KEY:
      newState = { api_key: payload };
      return { ...state, ...newState };

    case NEW_INTEGRATION_SAT_DATA:
      newState = { sat: payload };
      return { ...state, ...newState };

    case NEW_INTEGRATION_SAT_DOWNLOADS:
      newState = { sat_downloads: payload };
      return { ...state, ...newState };

    case NEW_INTEGRATION_SAT_ERRORS:
      newState = { satErrors: payload };
      return { ...state, ...newState };

    case NEW_SPEI_DATA:
      newState = { spei: payload };
      return { ...state, ...newState };

    case NEW_STRIPE_DATA:
      newState = { stripe: payload };
      return { ...state, ...newState };

    case NEW_OXXO_DATA:
      newState = { oxxo: payload };
      return { ...state, ...newState };

    case NEW_CONEKTA_DATA:
      newState = { conekta: payload };
      return { ...state, ...newState };

    case NEW_CONTPAQI_DATA:
      if (payload.serial_number) {
        payload.is_enabled = 1;
      }
      newState = { contpaqi: payload };
      return { ...state, ...newState };

    case NEW_FISERV_INTEGRATION_DATA:
      newState = { fiserv: payload };
      return { ...state, ...newState };

    case NEW_INTEREST_INTEGRATION_DATA:
      newState = { interest: payload };
      return { ...state, ...newState };
    
    case UPDATE_INTEREST_INTEGRATION_DATA:
      newState = { interest: [payload] };
      return { ...state, ...newState };

    case NEW_SAP_INTEGRATION_DATA:
      newState = { sap_bo: payload }
      return { ...state, ...newState };

    case GET_RELATION_CONCEPTS:
      newState = { relationConcepts: payload, isLoading: false };
      return { ...state, ...newState };

    case SEND_RELATION_CONCEPTS:
      newState = { isLoading: false };
      return { ...state, ...newState };

    case TOGGLE_LOADING:
      return { ...state, isLoading: payload };

    case UPDATE_INTEGRATION:
      newState = { [payload.integration]: { ...state[payload.integration], ...payload.newAttributes } };
      return { ...state, ...newState };

    case RESET_ACCOUNT:
    case LOG_OUT:
      newState = { initialState };
      return { ...state, ...initialState };
    
    case GET_STP_INTEGRATION:
      return {
        ...state,
        stp: action.payload.data
      }

    default:
      return state;
  } // END switch

} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/integrationsReducer.js